import { ReactElement, useEffect, useState } from 'react';
import './NumberFilter.scss';

interface NumberFilterProps {
  label: string;
  min: number | null;
  max: number | null;

  onChange: Function;
}

function NumberFilter({ label, min, max, onChange }: NumberFilterProps): ReactElement {
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);

  useEffect(() => {
    setMinValue(min);
    setMaxValue(max);
  }, [min, max]);

  const updateMinValue = (value) => {
    setMinValue(value * 1);
  };

  const updateMaxValue = (value) => {
    setMaxValue(value * 1);
  };

  const commit = () => {
    onChange({ min: minValue, max: maxValue });
  };

  return (
    <div className="cs-number-filter-ctx">
      <div className="value min-ctx">
        <input type="number" placeholder="Min" value={minValue || ''} onChange={(e) => updateMinValue(e.currentTarget.value)} onBlur={commit} />
      </div>
      <div className="symbol">&lt;=</div>
      <div className="label">{label}</div>
      <div className="symbol">&lt;=</div>
      <div className="value max-ctx">
        <input type="number" placeholder="Max" value={maxValue || ''} onChange={(e) => updateMaxValue(e.currentTarget.value)} onBlur={commit} />
      </div>
    </div>
  );
}

export default NumberFilter;
